// Remembers which hamburger-menu section the user last had open, so
// returning to the menu after a full page navigation doesn't always
// fall back to the first section.
const STORAGE_KEY = 'schu:navMenu:lastGroupId';
const GROUP_SELECTOR = '.globalHeader__navGroup[data-nav-group-id]';
const LOGO_LINK_SELECTOR = '.globalHeader__logo a';

function getStorage()
{
  try
  {
    return window.sessionStorage;
  }
  catch
  {
    // Storage can be unavailable (private browsing, disabled, etc.)
    return null;
  }
}

function getLastGroupId()
{
  const storage = getStorage();
  if (!storage) return null;

  try
  {
    return storage.getItem(STORAGE_KEY);
  }
  catch
  {
    return null;
  }
}

function setLastGroupId(id)
{
  const storage = getStorage();
  if (!storage) return;

  try
  {
    storage.setItem(STORAGE_KEY, id);
  }
  catch
  {
    // Ignore write failures (quota, disabled storage, etc.)
  }
}

function clearLastGroupId()
{
  const storage = getStorage();
  if (!storage) return;

  try
  {
    storage.removeItem(STORAGE_KEY);
  }
  catch
  {
    // Ignore removal failures (quota, disabled storage, etc.)
  }
}

function restoreLastOpenGroup()
{
  const lastGroupId = getLastGroupId();
  if (!lastGroupId) return;

  const match = document.querySelector(
    `${GROUP_SELECTOR}[data-nav-group-id="${lastGroupId}"]`,
  );
  if (match)
  {
    match.setAttribute('open', '');
  }
}

export function initNavMenuState()
{
  if (!document.querySelector(GROUP_SELECTOR)) return;

  restoreLastOpenGroup();

  // Capture phase because `toggle` events on <details> do not bubble
  document.addEventListener(
    'toggle',
    function (e)
    {
      const details = e.target;
      if (details.open && details.matches(GROUP_SELECTOR))
      {
        setLastGroupId(details.dataset.navGroupId);
      }
    },
    true,
  );

  // Going home via the logo should reset the menu to its default section,
  // not restore wherever the user last was
  document.addEventListener('click', function (e)
  {
    if (e.target.closest(LOGO_LINK_SELECTOR))
    {
      clearLastGroupId();
    }
  });
}
